import { render, staticRenderFns } from "./libraryrightclick.vue?vue&type=template&id=7a824400&"
import script from "./libraryrightclick.vue?vue&type=script&lang=js&"
export * from "./libraryrightclick.vue?vue&type=script&lang=js&"
import style0 from "./libraryrightclick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports